import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialMapComponent } from './map.component';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';




@NgModule({
  declarations: [
    MaterialMapComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    FlexLayoutModule,
    FormsModule
  ],
  exports: [MaterialMapComponent],
})
export class MaterialMapModule {}